<template>
  <div>
    <div v-if="user" class="header">
      <div class="container">
        <div class="header-content">
          <avatar v-if="user.photoUrl" :image-url="user.photoUrl" />

          <div>
            <h1 class="secondary-font">
              {{ user.displayName || 'Anonymous' }}
            </h1>

            <align>
              <pro-label />

              <icon-button
                v-if="!!profileLink"
                tooltip="Message owner"
                icon="question_answer"
                as="a"
                target="_blank"
                :href="profileLink"
              />
            </align>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <spinner v-if="loading" />

      <div v-else class="tabs">
        <tab
          v-for="collection in collections"
          :key="collection.id"
          as="router-link"
          :to="`/showcase/${collection.uid}?collectionId=${collection.id}`"
          :active="collection.id === $route.query.collectionId"
        >
          {{ collection.name }}
        </tab>
      </div>

      <showcase-collection-view
        v-if="$route.query.collectionId"
        v-show="!loading"
        :collection-id="$route.query.collectionId"
      />
    </div>
  </div>
</template>

<script>
import ProLabel from '@cardladder/shared/components/ProLabel';

import ShowcaseCollectionView from './ShowcaseCollectionView';

import { searchService } from '@/services';

export default {
  components: {
    ProLabel,
    ShowcaseCollectionView,
  },

  data() {
    return {
      user: null,
      collections: [],
      loading: true,
    };
  },


  mounted() {
    this.load();
  },

  computed: {
    profileLink() {
      if (!this.user || !this.user.profileLink) {
        return '';
      }

      if (!this.user.profileLink.includes('http') && this.user.profileLink.includes('@')) {
        return `https://instagram.com/${this.user.profileLink.replace('@', '')}`;
      }

      return this.user.profileLink;
    },
  },

  methods: {
    async load() {
      this.loading = true;

      try {
        this.user = await searchService.getDoc('users', this.$route.params.id);

        const data = await searchService.search({
          index: 'collections',
          filters: {
            uid: this.$route.params.id,
            public: true,
          },
        });

        this.collections = data.hits;

        if (!this.$route.query.collectionId) {
          this.$router.replace({ query: { collectionId: this.collections[0].id } });
        }

        this.loading = false;
      } catch (e) {
        this.$router.replace('/showcase');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  @include container;
}

.results {
  position: relative;
  flex: 1;
  margin-top: $gp;
}

.list {
  display: flex;
  flex-direction: column;

  @media($medium-down) {
    margin: 0 (-$gp);
  }
}

.back-link {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: $color-gray-5;

  &:hover span {
    text-decoration: underline;
  }
}

.header {
  margin-bottom: -$gp;
  background-color: var(--theme-highlight);

  h1 {
    text-transform: none;
    font-weight: bold;
    margin-bottom: $gp * .5;
  }

  .header-content {
    display: flex;
    align-items: center;
    gap: $gp * 2;
    --avatar-size: 100px;

    @media($medium-down) {
      gap: $gp;
      --avatar-size: 80px;
    }
  }
}

.tabs {
  margin-bottom: $gp;
}
</style>
